<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="league._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ league.leagueTitle }}</h3>
            <p class="text-center">{{ status().name }}</p>

            <div class="em-separator separator-dashed"></div>
            <ul class="nav flex-column">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  v-if="status().code < 3"
                  :to="{ path: 'leagueReport', query: { id: league._id } }"
                >
                  <i class="la la-bell la-2x align-middle pr-2"></i>گزارش
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div v-if="league.winRoles" class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات لیگ</h4>
          </div>
          <div class="widget-body">
            <form id="leagueForm" class="form-horizontal">
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بلیط ورودی لیگ</label>
                <div class="col-lg-6">
                  <input type="number" name="ticketCount" class="form-control" v-model="league.ticketCount" />
                </div>
              </div>

              <div>
                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد کل انرژی کاربر</label>
                  <div class="col-lg-6">
                    <input
                      type="number"
                      placeholder="10"
                      value="10"
                      name="startPlayCount"
                      class="form-control"
                      v-model="league.startPlayCount"
                    />
                  </div>
                </div>

                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                    >زمان لازم برای پر شدن یک انرژی به ثانیه</label
                  >
                  <div class="col-lg-6">
                    <input
                      type="number"
                      placeholder="3600"
                      value="3600"
                      name="startPlayCount"
                      class="form-control"
                      v-model="league.timeToFillOneEnergyInSeconds"
                    />
                  </div>
                </div>

                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                    >تعداد تیکت مورد نیاز برای پر کردن کامل پک انرژی</label
                  >
                  <div class="col-lg-6">
                    <input
                      type="number"
                      name="ticketsForExtraPlay"
                      class="form-control"
                      placeholder="8"
                      value="8"
                      v-model="league.ticketsForExtraPlay"
                    />
                  </div>
                </div>
              </div>

              <!-- league english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام لیگ فارسی</label>
                <div class="col-lg-6">
                  <input type="text" name="leagueTitle" class="form-control" v-model="league.leagueTitle" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام لیگ انگلیسی</label>
                <div class="col-lg-6">
                  <input type="text" name="leagueTitleEn" class="form-control" v-model="league.leagueTitleEn" />
                </div>
              </div>

              <!-- ground  advertisment text -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >پیام تبلیغاتی (۵ - ۸) فارسی</label
                >
                <div class="col-lg-6">
                  <input type="text" name="advText" class="form-control" v-model="league.advText" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >پیام تبلیغاتی (۵ - ۸) انگلیسی</label
                >
                <div class="col-lg-6">
                  <input type="text" name="advTextEn" class="form-control" v-model="league.advTextEn" />
                </div>
              </div>

              <!-- league ground name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمین لیگ</label>
                <div class="col-lg-6">
                  <select name="ground" class="form-control" id>
                    <option
                      v-for="ground in grounds"
                      :key="ground._id"
                      :value="ground._id"
                      :selected="ground._id == league.ground"
                      >{{ ground.groundName }}</option
                    >
                  </select>
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت لیگ</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id>
                    <option value="true" :selected="league.isAvailable">فعال</option>
                    <option value="false" :selected="!league.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <div class="em-separator separator-dashed"></div>
              <!-- league time -->
              <div class="widget-header no-actions d-flex align-items-center">
                <h4>زمان برگذاری لیگ</h4>
              </div>
              <!-- start Date -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان شروع لیگ</label>
                <date-picker
                  name="startDate"
                  type="datetime"
                  inputFormat="YYYY-MM-DD HH:mm"
                  display-format="jYYYY-jMM-jDD HH:mm"
                  format="YYYY-MM-DDTHH:mm:SSZ"
                  locale="fa,en"
                  altFormat="MM-DD-YYYY HH:mm"
                  v-model="startDate"
                ></date-picker>
                <div class="col-lg-6"></div>
              </div>

              <!-- end Date -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان پایان لیگ</label>
                <date-picker
                  name="startDate"
                  type="datetime"
                  inputFormat="YYYY-MM-DD HH:mm"
                  display-format="jYYYY-jMM-jDD HH:mm"
                  format="YYYY-MM-DDTHH:mm:SSZ"
                  locale="fa,en"
                  altFormat="MM-DD-YYYY HH:mm"
                  v-model="endDate"
                ></date-picker>
                <div class="col-lg-6"></div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت قوانین نمایش</label>
                <div class="col-lg-6">
                  <select name="isShowRulesActive" class="form-control" id v-model="league.isShowRulesActive">
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <div v-if="league.isShowRulesActive" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"> قوانین نمایش</label>
                <div class="col-lg-6">
                  <select name="showRules" class="form-control" id v-model="league.showRules" multiple>
                    <option disabled value="">انتخاب کنید</option>
                    <option v-for="rule in rules" :key="rule._id" :value="rule._id">{{ rule.title }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >وضعیت قوانین ورود رایگان</label
                >
                <div class="col-lg-6">
                  <select
                    name="isFreeEnteranceRulesActive"
                    class="form-control"
                    id
                    v-model="league.isFreeEnteranceRulesActive"
                  >
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <div v-if="league.isFreeEnteranceRulesActive" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"> قوانین ورود رایگان</label>
                <div class="col-lg-6">
                  <select
                    name="freeEnteranceRules"
                    class="form-control"
                    id
                    v-model="league.freeEnteranceRules"
                    multiple
                  >
                    <option disabled value="">انتخاب کنید</option>
                    <option v-for="rule in rules" :key="rule._id" :value="rule._id">{{ rule.title }}</option>
                  </select>
                </div>
              </div>

              <div class="em-separator separator-dashed"></div>
              <!-- league win roles -->
              <div class="widget-header no-actions d-flex align-items-center">
                <h4>قوانین بردن در لیگ</h4>
              </div>
              <!-- winRoles -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع بردن بازی</label>
                <div class="col-lg-6">
                  <select name="winRoles" class="form-control" id>
                    <option value="true" :selected="league.winRoles.goal.isActive">گل</option>
                    <option value="false" :selected="league.winRoles.time.isActive">زمان</option>
                  </select>
                </div>
              </div>
              <!-- max goals -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد گل</label>
                <div class="col-lg-6">
                  <input type="number" name="maxGoal" class="form-control" :value="league.winRoles.goal.maxGoal" />
                </div>
              </div>
              <!-- max time -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان بازی به ثانیه</label>
                <div class="col-lg-6">
                  <input type="number" name="maxTime" class="form-control" :value="league.winRoles.time.maxTime" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">امتیاز برنده لیگ</label>
                <div class="col-lg-6">
                  <input
                    type="number"
                    name="winnerScore"
                    class="form-control"
                    v-model="league.winnerScore"
                    value="100"
                  />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">امتیاز بازنده لیگ</label>
                <div class="col-lg-6">
                  <input type="number" name="looserScore" class="form-control" v-model="league.looserScore" value="0" />
                </div>
              </div>
              <div class="em-separator separator-dashed"></div>
              <!-- chat english name -->
              <div class="widget-header no-actions d-flex align-items-center">
                <h4>جایزه برنده لیگ</h4>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">عنوان</label>
                <div class="col-lg-6">
                  <input type="text" name="prizeName" class="form-control" v-model="league.prizeName" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">عنوان انگلیسی</label>
                <div class="col-lg-6">
                  <input type="text" name="prizeNameEn" class="form-control" v-model="league.prizeNameEn" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع جایزه</label>
                <div class="col-lg-6">
                  <select v-model="prizeType" class="form-control" name="prizeType">
                    <option value disabled>انتخاب کنید</option>
                    <option value="coin">سکه</option>
                    <option value="asset">asset های بازی</option>
                    <option value="Other">دیگر</option>
                  </select>
                </div>
              </div>

              <div v-if="prizeType == 'asset'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع asset</label>
                <div class="col-lg-6">
                  <select @change="getAssetItems" v-model="assetType" class="form-control" name="assetType">
                    <option value selected disabled>انتخاب کنید</option>
                    <option value="Skin">مهره</option>
                    <option value="Formation">ترکیب</option>
                    <option value="Chat">ایموجی</option>
                    <option value="Avatar">اواتار</option>
                  </select>
                </div>
              </div>

              <div v-if="prizeType == 'asset' && assetType != ''" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام asset</label>
                <div class="col-lg-6">
                  <select class="form-control" name="asset">
                    <option value selected disabled>انتخاب کنید</option>
                    <option
                      v-for="item in itemsToAdd"
                      :key="item._id"
                      :value="item._id"
                      :selected="league.prizeItem == item._id"
                      >{{ item.name }}</option
                    >
                  </select>
                </div>
              </div>
              <div v-if="prizeType == 'coin'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">مقدار سکه</label>
                <div class="col-lg-6">
                  <input type="number" name="coinValue" class="form-control" :value="league.coinValue" />
                </div>
              </div>

              <div class="col-lg-12 mt-2">
                <div class="mt-2 mb-2 position-relative">
                  <div class="col-12">
                    <label class="col-4" for="">{{ league.leagueBanner ? 'انتخاب تصویر بنر جدید' : 'بنر لیگ' }}</label>
                    <input
                      accept="image/*"
                      id="image"
                      name="image"
                      @change="bannerFileSelectet"
                      class="col-8"
                      type="file"
                    />
                  </div>
                </div>
              </div>

              <div v-if="league.leagueBanner != null">
                <img class="w-25 h-auto mx-auto" :src="league.leagueBanner" alt="" />
              </div>

              <div class="col-lg-12 mt-2">
                <div class="mt-2 mb-2 position-relative">
                  <div class="col-12">
                    <label class="col-4" for="">{{
                      league.leaguePrizeIcon ? 'انتخاب تصویر جاییزه جدید' : 'تصویر جاییزه'
                    }}</label>
                    <input
                      accept="image/*"
                      id="image"
                      name="image"
                      @change="prizeFileSelectet"
                      class="col-8"
                      type="file"
                    />
                  </div>
                </div>
              </div>

              <div v-if="league.leaguePrizeIcon != null">
                <img class="w-25 h-auto mx-auto" :src="league.leaguePrizeIcon" alt="" />
              </div>

              <!-- League Boosters -->
              <div class="em-separator separator-dashed"></div>
              <div class="widget-header no-actions d-flex align-items-center">
                <h4>تنظیمات بوستر های لیگ</h4>
              </div>
              <div class="col-8">
                <h3>بوستر های روزانه لیگ</h3>
                <button class="btn btn-success" @click.prevent="league.defaultBoosters.push({ titleTopFa: '' })">
                  بوستر جدید
                </button>
                <button class="btn btn-primary mx-2" @click.prevent="generateDailyBoosters">
                  ساخت خودکار بوسترهای روزانه
                </button>

                <div
                  class="card border-radius-3 p-3 my-2"
                  style="border-radius: 20px; overflow: hidden;"
                  v-for="(booster, index) in league.defaultBoosters"
                  :key="index"
                >
                  <h3>بوستر شماره {{ index + 1 }}</h3>
                  <div class="my-2">
                    <label :for="`league-default-boost-${index}`">مقدار عددی بوستر</label>
                    <input
                      class="form-control"
                      :id="`league-default-boost-${index}`"
                      type="number"
                      v-model="booster.boost"
                      placeholder="1"
                      value="1"
                    />
                  </div>
                  <div class="my-2">
                    <label :for="`league-default-booster-order-${index}`">ترتیب عددی</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-order-${index}`"
                      type="number"
                      v-model="booster.order"
                      placeholder="1"
                      value="1"
                    />
                  </div>
                  <div class="my-2">
                    <label class="col-12" :for="`league-default-booster-activeFrom-${index}`"
                      >زمان شروع فعال سازی</label
                    >
                    <date-picker
                      :id="`league-default-booster-activeFrom-${index}`"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="booster.activeFrom"
                    ></date-picker>
                  </div>

                  <div class="my-2">
                    <label class="col-12" :for="`league-default-booster-activeTo-${index}`">زمان پایان فعال سازی</label>
                    <date-picker
                      :id="`league-default-booster-activeTo-${index}`"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="booster.activeTo"
                    ></date-picker>
                  </div>

                  <div class="my-2">
                    <label :for="`league-default-booster-titleTopFa-${index}`">عنوان فارسی بالایی</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleTopFa-${index}`"
                      type="text"
                      v-model="booster.titleTopFa"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>

                  <div class="my-2">
                    <label :for="`league-default-booster-titleDownFa-${index}`">عنوان فارسی پایین</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleDownFa-${index}`"
                      type="text"
                      v-model="booster.titleDownFa"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>

                  <div class="my-2">
                    <label :for="`league-default-booster-titleTopEn-${index}`">عنوان انگلیسی بالایی</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleTopEn-${index}`"
                      type="text"
                      v-model="booster.titleTopEn"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>

                  <div class="my-2">
                    <label :for="`league-default-booster-titleDownEn-${index}`">عنوان انگلیسی پایین</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleDownEn-${index}`"
                      type="text"
                      v-model="booster.titleDownEn"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>

                  <button class="btn btn-danger" @click.prevent="league.defaultBoosters.splice(index, 1)">
                    حذف بوستر
                  </button>
                </div>
              </div>
              <div class="col-8">
                <h3>بوستر های قابل استفاده کاربر</h3>
                <div
                  class="card border-radius-3 p-3 my-2"
                  style="border-radius: 20px; overflow: hidden;"
                  v-for="(booster, index) in league.userBoosters"
                  :key="index"
                >
                  <h3>بوستر شماره {{ index + 1 }}</h3>
                  <div class="my-2">
                    <label :for="`league-default-boost-${index}`">مقدار عددی بوستر</label>
                    <input
                      class="form-control"
                      :id="`league-default-boost-${index}`"
                      type="number"
                      v-model="booster.boost"
                      placeholder="1"
                      value="1"
                    />
                  </div>
                  <div class="my-2">
                    <label :for="`league-default-booster-order-${index}`">ترتیب عددی</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-order-${index}`"
                      type="number"
                      v-model="booster.order"
                      placeholder="1"
                      value="1"
                    />
                  </div>
                  <div class="my-2">
                    <label :for="`league-default-booster-tickets-${index}`">تیکت مورد نیاز</label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-tickets-${index}`"
                      type="number"
                      v-model="booster.tickets"
                      placeholder="1"
                      value="1"
                    />
                  </div>
                  <div class="my-2">
                    <label :for="`league-default-booster-titleFa-${index}`">عنوان فارسی </label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleFa-${index}`"
                      type="text"
                      v-model="booster.titleFa"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>

                  <div class="my-2">
                    <label :for="`league-default-booster-titleEn-${index}`">عنوان انگلیسی </label>
                    <input
                      class="form-control"
                      :id="`league-default-booster-titleEn-${index}`"
                      type="text"
                      v-model="booster.titleEn"
                      placeholder="X1"
                      value="X1"
                    />
                  </div>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/leagues">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leagueService from '../../../../services/league';
import groundService from '../../../../services/ground';
import shopService from '../../../../services/shop';
import PermissionService from '../../../../services/UsersRulePermissions';

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import moment from 'moment';
export default {
  name: 'leaguedetail',
  data() {
    return {
      league: {},
      grounds: [],
      prizeType: '',
      assetType: '',
      itemsToAdd: [],
      startDate: '',
      endDate: '',
      file: null,
      fileIcon: null,
      rules: [],
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  created() {
    this.getleague();
    this.getGrounds();
    this.getRules();
  },
  methods: {
    async getRules() {
      try {
        const resData = await PermissionService.getRules({});
        this.rules = resData;
      } catch (err) {
        console.log(err);
      }
    },
    bannerFileSelectet(e) {
      this.file = e.target.files[0];
    },
    prizeFileSelectet(e) {
      this.fileIcon = e.target.files[0];
    },
    async getleague() {
      try {
        if (this.$route.query.id) {
          const league = await leagueService.findLeagueById(this.$route.query.id);
          this.league = league;
          if (league.playCountPackages) {
            this.league.playCountPackages = league.playCountPackages.join(',');
          }
          const start = new Date(league.startDate);
          const end = new Date(league.endDate);
          this.startDate = format(start);
          this.endDate = format(end);
          if (league.prizeKind == 'coin' || league.prizeKind == 'Other') {
            this.prizeType = league.prizeKind;
          } else {
            this.prizeType = 'asset';
            this.assetType = league.prizeKind;
            this.getAssetItems();
          }
        } else {
          this.league = {
            endDate: '',
            startDate: '',
            isAvailable: false,
            leagueTitle: '',
            winRoles: {
              goal: {
                isActive: true,
                maxGoal: 2,
              },
              time: {
                isActive: false,
                maxTime: 120,
              },
            },
            userBoosters: [
              {
                isDefault: true,
                order: 0,
                boost: 1,
                tickets: 0,
                titleFa: 'رایگان',
                titleEn: 'Free',
              },
              {
                isDefault: false,
                order: 1,
                boost: 2,
                tickets: 2,
                titleFa: 'x2',
                titleEn: 'x2',
              },
              {
                isDefault: false,
                order: 2,
                boost: 5,
                tickets: 5,
                titleFa: 'x5',
                titleEn: 'x5',
              },
            ],
            defaultBoosters: [],
          };
        }
      } catch (err) {
        console.log(err);
      }
      function format(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        var hh = date.getHours();
        var min = date.getMinutes();
        return [
          date.getFullYear(),
          '-',
          (mm > 9 ? '' : '0') + mm,
          '-',
          (dd > 9 ? '' : '0') + dd,
          ' ',
          (hh > 9 ? '' : '0') + hh,
          ':',
          (min > 9 ? '' : '0') + min,
        ].join('');
      }
    },

    async getGrounds() {
      try {
        const grounds = await groundService.getAllGrounds();
        this.grounds = grounds;
      } catch (err) {
        console.log(err);
      }
    },

    async getAssetItems() {
      try {
        switch (this.assetType) {
          case 'Avatar': {
            const avatarItems = await shopService.avatars();

            var i;
            for (i = 0; i < avatarItems.length; i++) {
              avatarItems[i].name = avatarItems[i]['avatarName'];
              avatarItems[i].index = avatarItems[i]['avatarIndex'];
              delete avatarItems[i].avatarName;
              delete avatarItems[i].avatarIndex;
            }
            this.itemsToAdd = avatarItems.filter(a => a.isDefault == false);
            break;
          }
          case 'Skin': {
            const skinItems = await shopService.skins();
            var j;
            for (j = 0; j < skinItems.length; j++) {
              skinItems[j].name = skinItems[j]['skinName'] + ' ' + skinItems[j].skinCat;
              skinItems[j].index = skinItems[j]['skinIndex'];
              delete skinItems[j].skinName;
              delete skinItems[j].skinIndex;
            }
            this.itemsToAdd = skinItems.filter(a => a.isDefault == false);
            console.log(this.itemsToAdd);
            break;
          }
          case 'Formation': {
            const formationItems = await shopService.formations();
            var k;
            for (k = 0; k < formationItems.length; k++) {
              formationItems[k].name = formationItems[k]['formationName'];
              formationItems[k].index = formationItems[k]['formationIndex'];
              delete formationItems[k].skinName;
              delete formationItems[k].skinIndex;
            }
            this.itemsToAdd = formationItems.filter(a => a.isDefault == false);
            console.log(this.itemsToAdd);
            break;
          }
          case 'Chat': {
            const chatItems = await shopService.chats();

            var l;
            for (l = 0; l < chatItems.length; l++) {
              chatItems[l].name = chatItems[l]['packageTitle'];
              chatItems[l].index = 0;
              delete chatItems[l].packageTitle;
            }
            this.itemsToAdd = chatItems.filter(a => a.isDefault == false);
            console.log(this.itemsToAdd);
            console.log(chatItems);
            break;
          }

          default:
            break;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      try {
        const form = document.getElementById('leagueForm');
        let prizeType;
        let prizeItem;
        let coinValue;
        if (form.prizeType.value == 'asset') {
          prizeType = form.assetType.value;
          prizeItem = form.asset.value;
        } else {
          if (form.prizeType.value == 'coin') coinValue = form.coinValue.value;
          prizeType = form.prizeType.value;
        }
        let packages = [];
        console.log(this.league.playCountPackages);
        if (this.league.playCountPackages) {
          packages = this.league.playCountPackages.split(',').map(Number);
        }
        const body = {
          _id: this.league._id,
          ticketCount: this.league.ticketCount,
          playCountIsInfinite: this.league.playCountIsInfinite,
          startPlayCount: this.league.startPlayCount,
          ticketsForExtraPlay: this.league.ticketsForExtraPlay,
          playCountPackages: packages,

          ground: form.ground.value,
          leagueTitle: form.leagueTitle.value,
          leagueTitleEn: form.leagueTitleEn.value,
          advText: form.advText.value,
          advTextEn: form.advTextEn.value,
          startDate: moment(this.startDate, 'YYYY-MM-DDTHH:mm:SSZ').toISOString(),
          endDate: moment(this.endDate, 'YYYY-MM-DDTHH:mm:SSZ').toISOString(),
          isAvailable: form.isAvailable.value == 'true',
          winRoles: {
            goal: {
              isActive: form.winRoles.value == 'true',
              maxGoal: form.maxGoal.value,
            },
            time: {
              isActive: form.winRoles.value == 'false',
              maxTime: form.maxTime.value,
            },
          },
          prizeName: form.prizeName.value,
          prizeNameEn: form.prizeNameEn.value,
          prizeKind: prizeType,
          prizeItem,
          coinValue,
          isFreeEnteranceRulesActive: this.league.isFreeEnteranceRulesActive,
          freeEnteranceRules: this.league.freeEnteranceRules,
          isShowRulesActive: this.league.isShowRulesActive,
          showRules: this.league.showRules,
          winnerScore: this.league.winnerScore,
          looserScore: this.league.looserScore,
          userBoosters: this.league.userBoosters,
          defaultBoosters: this.league.defaultBoosters,
          timeToFillOneEnergyInSeconds: this.league.timeToFillOneEnergyInSeconds,
        };

        for (let i = 0; i < body.defaultBoosters.length; i++) {
          const booster = body.defaultBoosters[i];
          booster.activeFrom = moment(booster.activeFrom, 'YYYY-MM-DDTHH:mm:SSZ').toISOString();
          booster.activeTo = moment(booster.activeTo, 'YYYY-MM-DDTHH:mm:SSZ').toISOString();
        }

        const data = this.obj2FormData(body);
        if (this.file != null) {
          data.append('file', this.file);
        }

        if (this.fileIcon != null) {
          data.append('fileIcon', this.fileIcon);
        }
        console.log(data);
        if (this.$route.query.id) {
          await leagueService.updateLeague(data);
        } else {
          await leagueService.creatLeague(data);
        }
        window.notif({ isError: false, mssg: 'لیگ ذخیره شد' });
      } catch (err) {
        console.log(err);
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }
    },
    parseLeagueDate(value) {
      if (!value) return null;
      const parsedDate = moment(value, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DDTHH:mm:SSZ', moment.ISO_8601], true);
      if (parsedDate.isValid()) return parsedDate;
      const fallbackDate = moment(value);
      return fallbackDate.isValid() ? fallbackDate : null;
    },
    getFaDayTitle(dayNumber) {
      const ordinalDays = [
        'اول',
        'دوم',
        'سوم',
        'چهارم',
        'پنجم',
        'ششم',
        'هفتم',
        'هشتم',
        'نهم',
        'دهم',
        'یازدهم',
        'دوازدهم',
        'سیزدهم',
        'چهاردهم',
        'پانزدهم',
        'شانزدهم',
        'هفدهم',
        'هجدهم',
        'نوزدهم',
        'بیستم',
        'بیست و یکم',
        'بیست و دوم',
        'بیست و سوم',
        'بیست و چهارم',
        'بیست و پنجم',
        'بیست و ششم',
        'بیست و هفتم',
        'بیست و هشتم',
        'بیست و نهم',
        'سی‌ام',
        'سی و یکم',
      ];

      if (dayNumber >= 1 && dayNumber <= ordinalDays.length) {
        return `روز ${ordinalDays[dayNumber - 1]}`;
      }
      return `روز ${dayNumber}`;
    },
    generateDailyBoosters() {
      const parsedStartDate = this.parseLeagueDate(this.startDate);
      const parsedEndDate = this.parseLeagueDate(this.endDate);

      if (!parsedStartDate || !parsedEndDate) {
        window.notif({ isError: true, mssg: 'ابتدا زمان شروع و پایان لیگ را مشخص کنید' });
        return;
      }

      const startOfLeague = parsedStartDate.clone().startOf('day');
      const endOfLeague = parsedEndDate.clone().startOf('day');

      if (endOfLeague.isBefore(startOfLeague)) {
        window.notif({ isError: true, mssg: 'زمان پایان لیگ نمی‌تواند قبل از زمان شروع باشد' });
        return;
      }

      const totalDays = endOfLeague.diff(startOfLeague, 'days') + 1;
      const generatedBoosters = [];

      for (let dayIndex = 0; dayIndex < totalDays; dayIndex++) {
        const dayNumber = dayIndex + 1;
        const dayStart = startOfLeague
          .clone()
          .add(dayIndex, 'days')
          .hour(0)
          .minute(0)
          .second(0);
        const dayEnd = dayStart.clone().hour(23).minute(59).second(0);

        generatedBoosters.push({
          boost: dayNumber,
          order: dayNumber,
          activeFrom: dayStart.format('YYYY-MM-DDTHH:mm:SSZ'),
          activeTo: dayEnd.format('YYYY-MM-DDTHH:mm:SSZ'),
          titleTopFa: this.getFaDayTitle(dayNumber),
          titleDownFa: `X${dayNumber}`,
          titleTopEn: `Day ${dayNumber}`,
          titleDownEn: `X${dayNumber}`,
        });
      }

      this.league.defaultBoosters = generatedBoosters;
      window.notif({ isError: false, mssg: 'بوسترهای روزانه به صورت خودکار ساخته شدند' });
    },
    obj2FormData(obj, formData = new FormData()) {
      const data = formData;
      const createFormData = function(obj, subKeyStr = '') {
        for (let i in obj) {
          let value = obj[i];
          let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i;
          if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            data.append(subKeyStrTrans, value);
          } else if (typeof value === 'object') {
            createFormData(value, subKeyStrTrans);
          }
        }
      };
      createFormData(obj);
      return data;
    },
    status() {
      const startDate = new Date(this.league.startDate);
      const endDate = new Date(this.league.endDate);
      const now = new Date();
      if (endDate < now) return { name: 'برگذار شده', code: 1 };
      if (startDate < now && endDate > now && this.league.isAvailable == true)
        return { name: 'در حال برگذازی', code: 2 };
      if (startDate > now && this.league.isAvailable) return { name: 'برگذار نشده - فعال', code: 3 };
      return { name: 'برگذار نشده - غیر فعال', code: 4 };
    },
  },
};
</script>
